import { render, staticRenderFns } from "./ResourcesUpdate.vue?vue&type=template&id=1ac96d93&"
import script from "./ResourcesUpdate.vue?vue&type=script&lang=js&"
export * from "./ResourcesUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports